import { ScheduleOrg } from '@wetags/schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useScheduleActivityAccess = () => {
  const [isScheduleActivityWetagEnabled, isLoadingScheduleActivityWetag] = ScheduleOrg.useWetag('schedule-activity');

  const { isScheduleV3FlagEnabled, isLoading: isLoadingV3Flag } =
    SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const isEnabled = isScheduleV3FlagEnabled && isScheduleActivityWetagEnabled;
  const isLoading = isLoadingV3Flag || isLoadingScheduleActivityWetag;

  return {
    isScheduleActivityEnabled: !isLoading && isEnabled,
    isLoading,
  };
};
